export interface IAppUpdate {
  appId: string;
  versions: IVersionUpdate[];
}

export interface IVersionUpdate {
  availableForUpgrade: boolean;
  availableForInstall: boolean;
  appName: string;
  appPrice: number;
  appVersion: string;
  appVersionId: string;
  appmarketAppId: string;
  sumAssignmentsBundle: number;
  sumAssignmentsRegular: number;
  timeCreated: string;
}
